import { Button } from '@mui/material';
import {
  KeyboardArrowDown as ExpandIcon,
  KeyboardArrowUp as CollapseIcon,
} from '@mui/icons-material';
import styled from '@emotion/styled';
import { type Dispatch, type SetStateAction } from 'react';
import FormattedMessageWithChallengeNaming from '@/components/FormattedMessageWithChallengeNaming';
import { useMediaQuery } from '@mui/system';

const ExpansionControlsWrapper = styled('div')(({ theme }) => ({
  marginTop: 4,
  marginBottom: 8,
  flex: 1,
  height: 20,
  display: 'flex',
  alignItems: 'center',
  p: {
    margin: 0,
    marginRight: 6,
    fontSize: 14,
    color: theme.palette.text.secondary,
  },
}));

type ColumnExpansionControlsProps = {
  columnExpanded: boolean;
  setColumnExpanded: Dispatch<SetStateAction<boolean>>;
  hiddenChallengesCount: number;
};

const ColumnExpansionControls = ({
  columnExpanded,
  setColumnExpanded,
  hiddenChallengesCount,
}: ColumnExpansionControlsProps) => {
  const useShorterLabels = useMediaQuery(
    '(max-width: 950px) and (min-width: 600px)',
  );

  return (
    <ExpansionControlsWrapper className="column-expansion-controls-wrapper">
      {!columnExpanded && (
        <p>
          <FormattedMessageWithChallengeNaming
            id={`portfolio.challenge_board.phase_column.older_challenges.${useShorterLabels ? 'label_short' : 'label'}.${hiddenChallengesCount === 1 ? 'singular' : 'plural'}`}
            values={{
              olderChallengesCount: hiddenChallengesCount,
            }}
          />
        </p>
      )}
      <Button
        className={!columnExpanded ? 'column-expand-button' : ''}
        color="secondary"
        size="small"
        startIcon={columnExpanded ? <CollapseIcon /> : <ExpandIcon />}
        onClick={() => setColumnExpanded(columnExpanded => !columnExpanded)}
      >
        <FormattedMessageWithChallengeNaming
          id={`portfolio.challenge_board.phase_column.older_challenges.${columnExpanded ? 'collapse_button' : 'expand_button'}${columnExpanded && useShorterLabels ? '.short_label' : ''}`}
        />
      </Button>
    </ExpansionControlsWrapper>
  );
};

export default ColumnExpansionControls;
